import React from 'react';
import { BasePage } from '../../../../framework/pages/BasePage';
import BarButtonFw, { BUTTON_DEFAULT } from '../../../../framework/bar-button/BarButtonFw';
import { UserUtil } from '../../../../util/UserUtil';
import { PAGE_MODE } from '../../../../constants/constants';
import FormFw from '../../../../framework/form/FormFw';
import { MessageUtil } from '../../../../util/MessageUtil';

export class DetalleEstacionAireModal extends BasePage {


  createPageProperties = (pageApi) => {
    return {
      title: 'Detalle de la Estación',
    };
  }

  renderPage(pageApi) {
    const getForm = () => pageApi.getComponent('form');

    const barHeaderConfig = {
      fields: [
        {
          ...BUTTON_DEFAULT.SAVE, onClick: () => {
            const index = pageApi.getApi().name.data.numIndex;
            const state = pageApi.getApi().name.data.getGrid().state.dataList;
            const newState = state.find(el => el.numIndex == index);
            pageApi.getApi().name.data.getGrid().updateItem({ ...newState, MUESTRA: '00000', ...getForm().getData() });
            pageApi.name.hideModal();
            MessageUtil("success", "Se actualizó correctamente.")
          }
        },
        { ...BUTTON_DEFAULT.RETURN, onClick: () => {
          pageApi.name.hideModal();
        } }
      ]
    };
    const formConfig = {
      autoLoad: true,
      layout: 'vertical',
      load: {
        queryId: 928,
        params: {
          ID_CADENA: pageApi.getParamId(),
          ID_PARAMETRO: pageApi.getApi().name.data.ID_PARAMETRO,
          ID_USUARIO: UserUtil.getUserId()
        },
        fnOk: (resp) => {
          getForm().setData(pageApi.getApi().name.data)
        }
      },
      fields: [
        {
          label: 'Detalles de Muestreo',
          fields: [
            { name: 'ESTACION', label: 'Estación', column: 4, type: 'text', labelName: 'ESTACION', readOnly: true, id: 'estacion_prueba' },
            { name: 'DESCRIPCION', label: 'Descripción', column: 4, type: 'text', labelName: 'DESCRIPCION', readOnly: true },
            { name: 'GEO_ESTACION', label: 'Georeferencia', column: 4, type: 'text', labelName: 'GEO_ESTACION', readOnly: true },
            { name: 'ALTITUD', label: 'Altitud', column: 4, type: 'text', labelName: 'ALTITUD', readOnly: true },
            { name: 'ZONA', label: 'Zona', column: 4, type: 'text', labelName: 'ZONA', readOnly: true },
            { name: 'CAUDAL_MUESTREO_INI', label: 'Caudal de muestreo inicial', column: 4, type: 'text', labelName: 'CAUDAL_MUESTREO_INI', editable: true },
            {
              type: "select",
              name: "ID_UM_CAUDAL_MUESTREO_INI",
              label: "Unidad Medida",
              labelName: "ID_UM_CAUDAL_MUESTREO_INI",
              column: 4,
              search: true,
              editable: true,
              load: { queryId: 799 },
            },
            { name: 'CAUDAL_MUESTREO_FIN', label: 'Caudal de muestreo final', column: 4, type: 'text', labelName: 'CAUDAL_MUESTREO_FIN', editable: true },
            {
              type: "select",
              name: "ID_UM_CAUDAL_MUESTREO_FIN",
              label: "Unidad Medida",
              labelName: "ID_UM_CAUDAL_MUESTREO_FIN",
              column: 4,
              search: true,
              editable: true,
              load: { queryId: 799 },
            },
            // { name: 'INCERTIDUMBRE_EXPANDIDA', label: 'Incertidumbre Expandida', column: 4, type: 'text', labelName: 'INCERTIDUMBRE_EXPANDIDA', editable: true }, 
            {
              type: "select",
              name: "FLG_EVALUACION_CONFORMIDAD",
              label: "Evaluación de conformidad",
              labelName: "FLG_EVALUACION_CONFORMIDAD",
              column: 4,
              load: {
                dataList: [
                  { value: '1', label: "Conforme" },
                  { value: '0', label: "No Conforme" },
                ],
              },
              editable: true,
              search: true,
              fnVisible: (_, row) => {
                if (row?.ES_ROL_EVALUADOR_CONFORMIDAD === true) {
                  return true
                } else if (row?.ES_ROL_EVALUADOR_CONFORMIDAD === false) {
                  return false
                }

                return true
              }
            },
            {
              type: "select",
              name: "FLG_DESVIACION_NORMA",
              label: "Desviación a la norma",
              labelName: "FLG_DESVIACION_NORMA",
              column: 4,
              load: {
                dataList: [
                  { value: '1', label: "Si" },
                  { value: '0', label: "No" },
                ],
              },
              editable: true,
              search: true,
              onChange: (value) => {
                if (value == 1) {
                  getForm()?.getConfig()?.fields[0]?.fields[11].setVisible(true);
                } else {
                  getForm()?.getConfig()?.fields[0]?.fields[11].setVisible(false);
                }
              }
            },
            { name: 'ESPECIFICAR_DESVIACION_NORMA', label: 'Especificar desviación a la norma', column: 4, type: 'textarea', labelName: 'ESPECIFICAR_DESVIACION_NORMA', editable: true, },
            {
              type: "select",
              name: "FLG_HECHO_INUSUAL",
              label: "Hecho Inusual",
              labelName: "FLG_HECHO_INUSUAL",
              column: 4,
              load: {
                dataList: [
                  { value: '1', label: "Si" },
                  { value: '0', label: "No" },
                ],
              },
              editable: true,
              search: true,
              onChange: (value) => {
                if (value == 1) {
                  getForm()?.getConfig()?.fields[0]?.fields[13].setVisible(true);
                } else {
                  getForm()?.getConfig()?.fields[0]?.fields[13].setVisible(false);
                }
              }
            },
            { name: 'ESPECIFICAR_HECHO_INUSUAL', label: 'Especificar hecho inusual', column: 4, type: 'textarea', labelName: 'ESPECIFICAR_HECHO_INUSUAL', editable: true, },
          ]
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW)
          formApi.load();
      }
    };

    return (
      <>
        <FormFw
          name="form"
          getParentApi={pageApi.getApi}
          config={formConfig}
        />
        <BarButtonFw
          name="agregarButton"
          getParentApi={pageApi.getApi}
          config={barHeaderConfig}
        />
      </>
    )

  }

}